module.exports = __webpack_public_path__ + "img/mobile-data-2-grey.bcf21a7d.svg";